import { useTheme } from "@emotion/react";
import React from "react";

type ValueProps = {
  value: string;
  onChange: (value: string) => void;
  isNullable?: boolean;
};

type Props = ValueProps & {
  label?: string;
  className?: string;
  enableNegativeValues?: boolean;
  isDisabled?: boolean;
  error?: string | null;
};

export const DecimalField: React.FC<Props> = (props) => {
  const theme = useTheme();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.isDisabled) return;

    const rawValue = event.target.value;
    let sanitizedValue = rawValue.replace(",", ".");

    if (sanitizedValue === "." || sanitizedValue === "-.") {
      sanitizedValue = sanitizedValue.startsWith("-") ? "-0." : "0.";
    }

    const regex = props.enableNegativeValues ? /^-?\d*\.?\d{0,2}$/ : /^\d*\.?\d{0,2}$/;

    if (regex.test(sanitizedValue) || sanitizedValue === "") {
      props.onChange(sanitizedValue);
    }
  };

  return (
    <div className={props.className} css={{ opacity: props.isDisabled ? 0.5 : 1 }}>
      {props.label && (
        <label
          css={{
            color: theme.colors.primary,
            fontSize: "0.875rem",
            fontFamily: theme.displayFontFamily,
            marginBottom: "0.25rem",
          }}
        >
          {props.label}
        </label>
      )}
      <input
        css={{
          width: "100%",
          border: "none",
          padding: "0.5rem 0.75rem",
          fontSize: "1rem",
          borderRadius: "6px",
          backgroundColor: theme.colors.primaryLight,
          ":focus": {
            outline: `1px solid ${props.error ? theme.colors.danger : theme.colors.primary}`,
            outlineOffset: "-1px",
          },
          disabled: {
            cursor: "text",
          },
        }}
        disabled={props.isDisabled}
        type="text"
        inputMode="decimal"
        // eslint-disable-next-line no-useless-escape
        pattern={props.enableNegativeValues ? `-?\d*\,?\d{0,2}` : `\d*\,?\d{0,2}`}
        value={props.value.replace(".", ",")}
        onChange={handleChange}
      />
      {props.error && (
        <span css={{ fontSize: "0.75rem", color: theme.colors.danger, marginTop: "0.125rem" }}>{props.error}</span>
      )}
    </div>
  );
};
